import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Images } from '../../global/GloblImages';



function LeftSide() {
  const [images, setImages] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const { bg_img1, bg_img2, bg_img3} = Images()

  useEffect(() => {
    const loadedImages = [bg_img1, bg_img2, bg_img3];
    setImages(loadedImages);
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 7000);

      return () => clearInterval(interval);
    }
  }, [images]);
  const settings = {

    dots: true, // Show dots for navigation
    infinite: true, // Infinite looping
    speed: 500, // Transition speed in milliseconds
    slidesToShow: 1, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll
    autoplay: true,
    autoplaySpeed: 2000, // Auto-play interval in milliseconds
    pauseOnHover: true, // Pause auto-play on hover
    customPaging: (i: any) => <div className="custom-dot d-flex align-items-center" />,
  };
  return (
    <>
      {/* <Box className='h-100 w-100 main-picture' sx={{ backgroundSize: "100% 100%", backgroundPosition: 'center center', fontSize: '64px', backgroundImage: `url(${imge1})` }}>
      </Box> */}
      <Box className='h-100 w-100 main-picture' overflow='hidden'>
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            style={{
              width: "100%",
              height: "100%",
              zIndex: 99,
              position: "absolute",
              top: "0px",
              left: "0px",
              display: index === currentIndex ? "block" : "none",
              opacity: index === currentIndex ? 1 : 0,
              transition: "opacity 1s ease-in-out",
              // borderRadius: "50% 0 0 50%",
            }}
            // className="sliderphoto img-fluid float-right cycle-slide cycle-slide-active"
            className={`sliderphoto img-fluid float-right cycle-slide cycle-slide-active ${index === currentIndex ? "zoom-animate" : ""
              }`}
            alt="Mystery Shopping"
            title="Mystery Shopping"
          />
        ))}
      </Box>
    </>

  )
}

export default LeftSide
